var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('user-add-account',{staticClass:"mt-2 pt-75"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }